// The empty value in the same shape as a form field: [] for a list, {} for a map such as remarks,
// '' for text.
const emptyLike = (current: unknown): unknown => {
    if (Array.isArray(current)) return [];
    if (current !== null && typeof current === 'object') return {};
    return '';
};

// The saved fields from a save response, ready to go back into the form. Only fields the form
// already has are taken: a response can also carry read-only display fields (such as UVP's
// beneficiary_groups), and sending those on the next save is rejected. An emptied field comes back
// as null and keeps its form shape, so its input stays controlled and its validation still applies.
export const toFormFields = (saved: object, current: object): Record<string, unknown> => {
    const currentValues = current as Record<string, unknown>;
    return Object.fromEntries(
        Object.entries(saved)
            .filter(([key]) => key in currentValues)
            .map(([key, value]) => [key, value === null ? emptyLike(currentValues[key]) : value]),
    );
};
